import ResolveFailedDelivery from "../symbols/resolveFailedDelivery";
import { HttpRequestPost } from "../../service";
import { roleName } from "../../utils/roles";
export interface IOrderFilter {
  Shop?: string[];
  Status: string[];
  DateRange?: string[];
}
const resolveFailedDeliveryAction = () => ({
  type: ResolveFailedDelivery.RESOLVE_FAILED_DELIVERY,
});
const resolveFailedDeliverySuccessAction = (data: any) => ({
  type: ResolveFailedDelivery.RESOLVE_FAILED_DELIVERY_SUCCESS,
  payload: data,
});
const resolveFailedDeliveryFailureAction = (data: any) => ({
  type: ResolveFailedDelivery.RESOLVE_FAILED_DELIVERY_FAILURE,
  payload: data,
});
const clearResolveFailedDeliveryAction = () => ({
  type: ResolveFailedDelivery.CLEAR_RESOLVE_FAILED_DELIVERY,
});
export function getResolveFailedDelivery(deliveryId: string, reason: string) {
  let url = `/${roleName().toLowerCase()}/delivery/${deliveryId}/recover/${reason}`;

  return (dispatch: any) => {
    dispatch(resolveFailedDeliveryAction());
    HttpRequestPost(
      url,
      dispatch,
      resolveFailedDeliverySuccessAction,
      resolveFailedDeliveryFailureAction,
      true,
      {},
      () => {}
    );
  };
}

export function clearResolveFailedDelivery() {
  return (dispatch: any) => {
    dispatch(clearResolveFailedDeliveryAction());
  };
}
